import { EventType } from './event-type.interface';

export const DOOR_LOCK: EventType = {
  name: 'Door Lock',
  description: 'When a door is locked or unlocked',
  route: 'door-lock',
  category: 'Security & Access',
  icon: 'door-lock',
  whitelist: [
    {
      proxy: 'relaysingle_doorlock_c4',
      events: [1, 2]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/door-lock.type.ts